import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useCoapplicantStore from '../../../store/coapplicantStore/useCoapplicantStore';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import { locator } from '../../../testing/e2e-locator/locator';

const CoapplicantResidenceSection = (): ReactNode => {
  const { t } = useTranslation();
  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const {
    computed: {
      coapplicantCurrentResidenceAddress,
      coapplicantCurrentResidenceAmount,
      coapplicantCurrentResidenceDuration,
      coapplicantCurrentResidenceType,
    },
  } = useCoapplicantStore();

  return (
    <span data-testid={locator.components.coapplicantResidenceSection.root}>
      <div className="head">
        <h3 data-testid={locator.components.coapplicantResidenceSection.h3}>
          {t('CoapplicantReviewPage.residence')}
        </h3>
        <Link
          data-testid={locator.components.coapplicantResidenceSection.editLink}
          to={`/applicant/${vehicleId}/coapp-edit-residence`}
        >
          {t('CoapplicantReviewPage.edit')}
        </Link>
      </div>

      <ul>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.type')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantResidenceSection.residenceType
              }
            >
              {coapplicantCurrentResidenceType}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.address')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantResidenceSection.address
              }
            >
              {coapplicantCurrentResidenceAddress}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.amount')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantResidenceSection.amount
              }
            >
              {coapplicantCurrentResidenceAmount}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.duration')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantResidenceSection.duration
              }
            >
              {coapplicantCurrentResidenceDuration}
            </dd>
          </dl>
        </li>
      </ul>
    </span>
  );
};

export default CoapplicantResidenceSection;
